var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64987 8.60987C8.09231 5.78741 12.3883 3.92667 14.5378 3.02765C20.675 0.460774 21.9503 0.0148807 22.7815 0.000156987C22.9643 -0.00308132 23.3731 0.0424773 23.6379 0.25852C23.8614 0.440943 23.9229 0.687369 23.9524 0.860326C23.9818 1.03328 24.0185 1.42728 23.9893 1.73514C23.6568 5.249 22.2177 13.7762 21.4856 17.7118C21.1758 19.3771 20.5658 19.9354 19.9753 19.9901C18.6919 20.1088 17.7174 19.1372 16.4744 18.3179C14.5294 17.0358 13.4305 16.2377 11.5425 14.9867C9.36064 13.5408 10.7751 12.7462 12.0185 11.4475C12.344 11.1076 17.9985 5.93584 18.1079 5.46668C18.1216 5.40801 18.1343 5.18929 18.0051 5.0738C17.8759 4.95831 17.6851 4.9978 17.5475 5.02921C17.3524 5.07373 14.2452 7.1389 8.22584 11.2247C7.34386 11.8337 6.545 12.1304 5.82924 12.1149C5.04018 12.0977 3.52233 11.6663 2.39397 11.2974C1.00999 10.8451 -0.0899676 10.6059 0.00581423 9.83761C0.0557033 9.43745 0.603723 9.0282 1.64987 8.60987Z",
    fill: "#A8A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c67c8813aebb51c80e1f019fd1657793.svg";
export { ForwardRef as ReactComponent };